import { graphql } from '~/lib/graphql'

export const RestaurantCoordinate = graphql(`
  fragment RestaurantCoordinate on Restaurant {
    longitude
    latitude
    zoom
  }
`)
